import { createRequest } from '@shared/services';

export async function getPromoProduct() {
    const request = createRequest<GetPromoProduct>({
        url: '/promo/product',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getPromoProductGiveaway(params: { product_id: string }) {
    const request = createRequest<GetBuyerPromoProduct>({
        url: '/promo/product-giveaway',
        method: 'GET',
        withAuthorization: true,
        params,
    });

    return request.execute();
}
